export class AssociaGruppo {
    idEquipe?:number;
    read?:boolean;
    write?:boolean;
}